import {
  InspectionStatus,
  InspectionItemStatus,
  InspectionStatusEvent,
  AssignmentStatus,
} from '../enums/InspectionStatus';

export interface StatusInfo {
  label: string;
  description: string;
  color: string;
  badge: string;
  icon?: string;
}

export const INSPECTION_STATUS_MAP: Record<InspectionStatus, StatusInfo> = {
  [InspectionStatus.Solicitacao]: {
    label: 'Solicitação',
    description: 'Inspeção foi criada mas ainda não foi direcionada',
    color: '#42A5F5',
    badge: 'NOVA',
    icon: 'FileAddOutlined',
  },
  [InspectionStatus.AguardandoDirecionamento]: {
    label: 'Aguardando Direcionamento',
    description: 'Primeiro status após solicitar a inspeção',
    color: '#ffa500',
    badge: 'AGUARDANDO',
    icon: 'ClockCircleOutlined',
  },
  [InspectionStatus.AguardandoAceitePrestadora]: {
    label: 'Aguardando Aceite da Prestadora',
    description: 'Após o banco direcionar',
    color: '#1890ff',
    badge: 'DIRECIONADO',
    icon: 'ClockCircleOutlined',
  },
  [InspectionStatus.AguardandoAceiteInspetor]: {
    label: 'Aguardando Aceite do Inspetor',
    description: 'Após direcionar para inspetor',
    color: '#52c41a',
    badge: 'DIRECIONADO',
    icon: 'ClockCircleOutlined',
  },
  [InspectionStatus.AceitaInspetor]: {
    label: 'Aguardando Agendamento',
    description: 'Se inspetor aceitar - aguarda agendamento',
    color: '#faad14',
    badge: 'ACEITO',
    icon: 'CalendarOutlined',
  },
  [InspectionStatus.Agendada]: {
    label: 'Agendado',
    description: 'Após agendar (inspetor ou prestadora)',
    color: '#13c2c2',
    badge: 'AGENDADO',
    icon: 'ScheduleOutlined',
  },
  [InspectionStatus.EmExecucao]: {
    label: 'Check-in Realizado',
    description: 'Após inspetor fazer checkin',
    color: '#eb2f96',
    badge: 'EM ANDAMENTO',
    icon: 'PlayCircleOutlined',
  },
  [InspectionStatus.AguardandoEnvioDados]: {
    label: 'Finalizado',
    description: 'Após preencher checklist e salvar',
    color: '#52c41a',
    badge: 'FINALIZADO',
    icon: 'CheckCircleOutlined',
  },
  [InspectionStatus.AguardandoRevisaoInspecao]: {
    label: 'Finalizado',
    description: 'Após preencher checklist e salvar',
    color: '#52c41a',
    badge: 'FINALIZADO',
    icon: 'CheckCircleOutlined',
  },
  [InspectionStatus.Aprovada]: {
    label: 'Finalizado',
    description: 'Após preencher checklist e salvar',
    color: '#52c41a',
    badge: 'FINALIZADO',
    icon: 'CheckCircleOutlined',
  },
  [InspectionStatus.DevolvidaParaAjustes]: {
    label: 'Aguardando Agendamento',
    description: 'Devolvido para agendamento',
    color: '#faad14',
    badge: 'AGUARDANDO',
    icon: 'CalendarOutlined',
  },
  [InspectionStatus.Concluida]: {
    label: 'Finalizado',
    description: 'Após preencher checklist e salvar',
    color: '#52c41a',
    badge: 'FINALIZADO',
    icon: 'CheckCircleOutlined',
  },
  [InspectionStatus.Cancelada]: {
    label: 'Cancelado',
    description: 'Inspeção foi cancelada',
    color: '#f5222d',
    badge: 'CANCELADO',
    icon: 'CloseCircleOutlined',
  },
  [InspectionStatus.RejeitadaPrestadora]: {
    label: 'Prestadora Recusou',
    description: 'Se prestadora recusar (banco pode direcionar novamente)',
    color: '#ff4d4f',
    badge: 'RECUSADO',
    icon: 'CloseCircleOutlined',
  },
  [InspectionStatus.Frustrada]: {
    label: 'Frustrado',
    description: 'Inspeção foi frustrada',
    color: '#d4380d',
    badge: 'FRUSTRADO',
    icon: 'StopOutlined',
  },
};

export const INSPECTION_ITEM_STATUS_MAP: Record<InspectionItemStatus, StatusInfo> = {
  [InspectionItemStatus.AguardandoDirecionamento]: {
    label: 'Aguardando Direcionamento',
    description: 'Primeiro status após solicitar a inspeção',
    color: '#ffa500',
    badge: 'AGUARDANDO',
    icon: 'ClockCircleOutlined',
  },
  [InspectionItemStatus.AguardandoAceitePrestadora]: {
    label: 'Aguardando Aceite da Prestadora',
    description: 'Após o banco direcionar',
    color: '#1890ff',
    badge: 'DIRECIONADO',
    icon: 'ClockCircleOutlined',
  },
  [InspectionItemStatus.PrestadoraRecusou]: {
    label: 'Prestadora Recusou',
    description: 'Se prestadora recusar (banco pode direcionar novamente)',
    color: '#ff4d4f',
    badge: 'RECUSADO',
    icon: 'CloseCircleOutlined',
  },
  [InspectionItemStatus.AguardandoDirecionamentoInspetor]: {
    label: 'Aguardando Direcionamento Inspetor',
    description: 'Se prestadora aceitar - aguarda direcionamento para inspetor',
    color: '#722ed1',
    badge: 'ACEITO',
    icon: 'UserOutlined',
  },
  [InspectionItemStatus.AguardandoAceiteInspetor]: {
    label: 'Aguardando Aceite do Inspetor',
    description: 'Após direcionar para inspetor',
    color: '#95de64',
    badge: 'DIRECIONADO',
    icon: 'ClockCircleOutlined',
  },
  [InspectionItemStatus.InspetorRecusou]: {
    label: 'Inspetor Recusou',
    description: 'Se inspetor recusar (prestadora pode direcionar novamente)',
    color: '#ff4d4f',
    badge: 'RECUSADO',
    icon: 'CloseCircleOutlined',
  },
  [InspectionItemStatus.AguardandoAgendamento]: {
    label: 'Aguardando Agendamento',
    description: 'Se inspetor aceitar - aguarda agendamento',
    color: '#faad14',
    badge: 'ACEITO',
    icon: 'CalendarOutlined',
  },
  [InspectionItemStatus.Agendado]: {
    label: 'Agendado',
    description: 'Após agendar (inspetor ou prestadora)',
    color: '#13c2c2',
    badge: 'AGENDADO',
    icon: 'ScheduleOutlined',
  },
  [InspectionItemStatus.CheckinRealizado]: {
    label: 'Check-in Realizado',
    description: 'Após inspetor fazer checkin',
    color: '#eb2f96',
    badge: 'EM ANDAMENTO',
    icon: 'PlayCircleOutlined',
  },
  [InspectionItemStatus.Finalizado]: {
    label: 'Aguardando Revisão do Laudo (PRESTADORA)',
    description: 'Laudo gerado aguardando revisão da prestadora',
    color: '#1890ff',
    badge: 'AGUARDANDO REVISÃO',
    icon: 'FileSearchOutlined',
  },
  [InspectionItemStatus.Cancelado]: {
    label: 'Cancelado',
    description: 'Item foi cancelado',
    color: '#f5222d',
    badge: 'CANCELADO',
    icon: 'CloseCircleOutlined',
  },
  [InspectionItemStatus.Frustrado]: {
    label: 'Frustrado',
    description: 'Item foi frustrado',
    color: '#d4380d',
    badge: 'FRUSTRADO',
    icon: 'StopOutlined',
  },
  [InspectionItemStatus.LaudoNegadoPorPrestadora]: {
    label: 'Laudo Negado por Prestadora',
    description: 'Prestadora rejeitou o laudo - correções necessárias',
    color: '#fa8c16',
    badge: 'CORREÇÃO PENDENTE',
    icon: 'EditOutlined',
  },
  [InspectionItemStatus.AguardandoRevisaoBanco]: {
    label: 'Aguardando Revisão do Laudo (BANCO)',
    description: 'Laudo aprovado pela prestadora aguardando revisão do banco',
    color: '#722ed1',
    badge: 'AGUARDANDO REVISÃO',
    icon: 'BankOutlined',
  },
  [InspectionItemStatus.LaudoNegadoPorBanco]: {
    label: 'Laudo Negado pelo Banco',
    description: 'Banco rejeitou o laudo - correções necessárias',
    color: '#ff4d4f',
    badge: 'CORREÇÃO PENDENTE',
    icon: 'CloseCircleOutlined',
  },
  [InspectionItemStatus.LaudoAceitoPeloBanco]: {
    label: 'Laudo Aceito pelo Banco',
    description: 'Laudo aprovado e aceito pelo banco',
    color: '#52c41a',
    badge: 'APROVADO',
    icon: 'CheckCircleOutlined',
  },
  [InspectionItemStatus.AguardandoRevisaoPrestadora]: {
    label: 'Aguardando Revisão da Prestadora',
    description: 'Laudo gerado aguardando revisão da prestadora',
    color: '#1890ff',
    badge: 'AGUARDANDO REVISÃO',
    icon: 'FileSearchOutlined',
  },
  [InspectionItemStatus.CorrecaoPeloInspetorBanco]: {
    label: 'Em Correção pelo Inspetor',
    description: 'Inspetor está corrigindo o laudo após rejeição do banco',
    color: '#fa8c16',
    badge: 'EM CORREÇÃO',
    icon: 'EditOutlined',
  },
  [InspectionItemStatus.AguardandoGeracaoLaudo]: {
    label: 'Checklist realizado',
    description: 'Checklist preenchido, aguardando geração do laudo',
    color: '#eb2f96',
    badge: 'CHECKLIST OK',
    icon: 'FileTextOutlined',
  },
  [InspectionItemStatus.TelevistoriaAgendada]: {
    label: 'Televistoria Agendada',
    description: 'Videoconferência agendada para televistoria',
    color: '#722ed1',
    badge: 'TELEVISTORIA',
    icon: 'VideoCameraOutlined',
  },
  [InspectionItemStatus.TelevistoriaFinalizada]: {
    label: 'Televistoria Finalizada',
    description: 'Televistoria realizada, aguardando geração do laudo',
    color: '#13c2c2',
    badge: 'TELEVISTORIA OK',
    icon: 'CheckCircleOutlined',
  },
  [InspectionItemStatus.LaudoDevolvido]: {
    label: 'Laudo Devolvido',
    description: 'Laudo foi devolvido para correções (sistema externo ou revisão)',
    color: '#fa8c16',
    badge: 'DEVOLVIDO',
    icon: 'RollbackOutlined',
  },
  [InspectionItemStatus.AguardandoPreenchimentoPrestadora]: {
    label: 'Aguardando Preenchimento (PRESTADORA)',
    description: 'Prestadora deve preencher o laudo diretamente (sem inspetor)',
    color: '#f59e0b',
    badge: 'LAUDO AUTOMÁTICO',
    icon: 'FormOutlined',
  },
  [InspectionItemStatus.ProcessandoScraping]: {
    label: 'Processando Scraping',
    description: 'Buscando imóveis comparáveis na região para análise automática',
    color: '#1890ff',
    badge: 'SCRAPING',
    icon: 'SearchOutlined',
  },
  [InspectionItemStatus.AguardandoAnaliseIA]: {
    label: 'Aguardando Análise IA',
    description: 'Scraping concluído, aguardando análise pela inteligência artificial',
    color: '#722ed1',
    badge: 'AGUARDANDO IA',
    icon: 'RobotOutlined',
  },
  [InspectionItemStatus.ProcessandoAnaliseIA]: {
    label: 'Processando Análise IA',
    description: 'A IA está analisando e selecionando as melhores amostras',
    color: '#722ed1',
    badge: 'IA PROCESSANDO',
    icon: 'LoadingOutlined',
  },
  [InspectionItemStatus.LaudoAutomaticoGerado]: {
    label: 'Laudo Automático Gerado',
    description: 'O laudo automático foi gerado com sucesso pela IA',
    color: '#52c41a',
    badge: 'LAUDO GERADO',
    icon: 'CheckCircleOutlined',
  },
  [InspectionItemStatus.ScrapingFalhou]: {
    label: 'Scraping Falhou',
    description: 'Falha ao buscar imóveis comparáveis. Tente novamente',
    color: '#ff4d4f',
    badge: 'FALHOU',
    icon: 'CloseCircleOutlined',
  },
  [InspectionItemStatus.AnaliseIAFalhou]: {
    label: 'Análise IA Falhou',
    description: 'Falha na análise da IA. Tente novamente',
    color: '#ff4d4f',
    badge: 'IA FALHOU',
    icon: 'CloseCircleOutlined',
  },
  [InspectionItemStatus.AguardandoCalculosPrestadora]: {
    label: 'Aguardando Cálculos da Prestadora',
    description: 'Banco encaminhou cálculos para outra prestadora',
    color: '#e040fb',
    badge: 'CÁLCULOS PENDENTES',
    icon: 'CalculatorOutlined',
  },
  [InspectionItemStatus.DevolvidoPeloBancoAposAceite]: {
    label: 'Devolvido pelo Banco (Pós-Aceite)',
    description: 'O banco devolveu o laudo para correções após o aceite inicial',
    color: '#fa541c',
    badge: 'DEVOLVIDO PÓS-ACEITE',
    icon: 'RollbackOutlined',
  },
  [InspectionItemStatus.DevolvidoPelaPrestadora]: {
    label: 'Devolvido pela Prestadora',
    description: 'Prestadora devolveu a inspeção ao inspetor para correção do checklist',
    color: '#fa8c16',
    badge: 'DEVOLVIDO',
    icon: 'RollbackOutlined',
  },
  [InspectionItemStatus.AguardandoPreenchimentoBanco]: {
    label: 'Aguardando Preenchimento (BANCO)',
    description: 'Laudo automático (AVM): o banco preenche o laudo e, ao enviar, ele já fica aceito',
    color: '#2f54eb',
    badge: 'LAUDO AVM',
    icon: 'BankOutlined',
  },
};

export const INSPECTION_EVENT_MAP: Record<InspectionStatusEvent, { label: string; description: string }> = {
  [InspectionStatusEvent.DIRECIONAR]: {
    label: 'Direcionar',
    description: 'Banco direciona inspeção para prestadora',
  },
  [InspectionStatusEvent.ACEITAR_PRESTADORA]: {
    label: 'Aceitar Prestadora',
    description: 'Prestadora aceita a inspeção',
  },
  [InspectionStatusEvent.REJEITAR_PRESTADORA]: {
    label: 'Rejeitar Prestadora',
    description: 'Prestadora rejeita a inspeção',
  },
  [InspectionStatusEvent.DIRECIONAR_INSPETOR]: {
    label: 'Direcionar Inspetor',
    description: 'Prestadora direciona para inspetor específico',
  },
  [InspectionStatusEvent.ACEITAR_INSPETOR]: {
    label: 'Aceitar Inspetor',
    description: 'Inspetor aceita a inspeção',
  },
  [InspectionStatusEvent.REJEITAR_INSPETOR]: {
    label: 'Rejeitar Inspetor',
    description: 'Inspetor rejeita a inspeção',
  },
  [InspectionStatusEvent.AGENDAR]: {
    label: 'Agendar',
    description: 'Agendar data/hora da inspeção',
  },
  [InspectionStatusEvent.REALIZAR_CHECKIN]: {
    label: 'Realizar Check-in',
    description: 'Inspetor realiza check-in no local',
  },
  [InspectionStatusEvent.FINALIZAR]: {
    label: 'Finalizar',
    description: 'Finalizar inspeção após preencher checklist',
  },
  [InspectionStatusEvent.CANCELAR]: {
    label: 'Cancelar',
    description: 'Cancelar inspeção',
  },
  [InspectionStatusEvent.FRUSTRAR]: {
    label: 'Frustrar',
    description: 'Frustrar inspeção (não foi possível realizar)',
  },
  [InspectionStatusEvent.ENVIAR_PARA_REVISAO_BANCO]: {
    label: 'Enviar para Revisão do Banco',
    description: 'Prestadora envia laudo diretamente para revisão do banco',
  },
  [InspectionStatusEvent.ENCAMINHAR_CALCULOS]: {
    label: 'Encaminhar Cálculos',
    description: 'Banco encaminha cálculos para outra prestadora',
  },
  [InspectionStatusEvent.ENVIAR_CALCULOS_PARA_BANCO]: {
    label: 'Enviar Cálculos para o Banco',
    description: 'Prestadora envia cálculos realizados para revisão do banco',
  },
};

export const ASSIGNMENT_STATUS_MAP: Record<AssignmentStatus, StatusInfo> = {
  [AssignmentStatus.PendingInspectorAcceptance]: {
    label: 'Aguardando Aceite do Inspetor',
    description: 'Inspetor foi designado mas ainda não aceitou',
    color: '#FFC107',
    badge: 'PENDENTE',
    icon: 'ClockCircleOutlined',
  },
  [AssignmentStatus.AcceptedByInspector]: {
    label: 'Aceito pelo Inspetor',
    description: 'Inspetor aceitou a atribuição',
    color: '#4CAF50',
    badge: 'ACEITO',
    icon: 'CheckCircleOutlined',
  },
  [AssignmentStatus.RejectedByInspector]: {
    label: 'Rejeitado pelo Inspetor',
    description: 'Inspetor rejeitou a atribuição',
    color: '#F44336',
    badge: 'REJEITADO',
    icon: 'CloseCircleOutlined',
  },
  [AssignmentStatus.Cancelled]: {
    label: 'Cancelado',
    description: 'Atribuição foi cancelada',
    color: '#9E9E9E',
    badge: 'CANCELADO',
    icon: 'StopOutlined',
  },
};

/**
 * Status que representam o fim do fluxo de inspeção.
 * LaudoAceitoPeloBanco é o status final do fluxo de laudo.
 */
export const TERMINAL_INSPECTION_STATUSES: InspectionItemStatus[] = [
  InspectionItemStatus.Cancelado,
  InspectionItemStatus.Frustrado,
];

export const ACTIVE_INSPECTION_STATUSES: InspectionItemStatus[] = [
  InspectionItemStatus.AguardandoDirecionamento,
  InspectionItemStatus.AguardandoAceitePrestadora,
  InspectionItemStatus.AguardandoDirecionamentoInspetor,
  InspectionItemStatus.AguardandoAceiteInspetor,
  InspectionItemStatus.AguardandoAgendamento,
  InspectionItemStatus.Agendado,
  InspectionItemStatus.CheckinRealizado,
  InspectionItemStatus.AguardandoGeracaoLaudo,
  InspectionItemStatus.TelevistoriaAgendada,
  InspectionItemStatus.TelevistoriaFinalizada,
  InspectionItemStatus.AguardandoPreenchimentoPrestadora,
  InspectionItemStatus.AguardandoPreenchimentoBanco,
];

export const AUTOMATIC_EVENTS: InspectionStatusEvent[] = [
  InspectionStatusEvent.REALIZAR_CHECKIN,
];
